import React from 'react';
import { FeatureFlagConfigChangeContext } from '../CommonProvider/FeatureFlagConfigChangeContext';
export function useFeatureFlagConfigChange() {
    const { onConfigChanged } = React.useContext(FeatureFlagConfigChangeContext);
    return onConfigChanged;
}
